module.exports = __webpack_public_path__ + "img/logo-3.1680d3a2.png";